import { render, staticRenderFns } from "./EditorPreview.vue?vue&type=template&id=2a4b0226&scoped=true&"
import script from "./EditorPreview.vue?vue&type=script&lang=ts&"
export * from "./EditorPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b0226",
  null
  
)

export default component.exports